import { apiGet, apiPost } from "./client";

export async function loginTeacher(email, password) {
  return apiPost("/auth/login", { email, password });
}

/**
 * Exchange a TutorCloud launch credential for a TEMA session.
 * Prefer { code } (TEMA_LAUNCH_MODE=code); { launchToken } remains for legacy_token.
 */
export async function exchangeLaunch({ code, launchToken } = {}) {
  const body = {};
  if (code) {
    body.code = code;
  } else if (launchToken) {
    body.launchToken = launchToken;
  } else {
    throw new Error("Launch requires code or launchToken");
  }
  return apiPost("/auth/launch", body);
}

/** @deprecated Prefer exchangeLaunch({ launchToken }) */
export async function exchangeLaunchToken(launchToken) {
  return exchangeLaunch({ launchToken });
}

export async function getTutorcloudLaunchUrl() {
  return apiGet("/auth/tutorcloud/launch");
}

export async function registerTeacher({ firstName, lastName, email, password }) {
  return apiPost(
    "/auth/register",
    { firstName, lastName, email, password },
    undefined,
    { retry: false },
  );
}
